import React, {useEffect, useState} from 'react';
import { Link, useNavigate } from "react-router-dom";
import { connect, setStore } from "trim-redux";
import Button from "@mui/material/Button";
import {Close} from "@mui/icons-material";
import {withStyles} from "@mui/styles";
import { Styles } from "../../../../config/design/styles";
import {Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Menu, MenuItem, Typography} from "@mui/material";
import {useTranslation} from "react-i18next";
import {removeLocalStorages} from "../../../../config/values";

function LogoutDialog({ logoutOpen,closeDialog }) {
    const [dialogOpen, setDialogOpen] = React.useState(logoutOpen);
    const navigate = useNavigate();
    const { t } = useTranslation();

    useEffect(() => {
        setDialogOpen(logoutOpen)
    },[logoutOpen]);

    const handleLogout = () => {
        removeLocalStorages()
        window.location.reload();
    };
    const handleCloseDialog = () => {
        setDialogOpen(false);
        closeDialog()
    }
    return (
        <Dialog open={dialogOpen} onClose={() => handleCloseDialog()}>
            <DialogTitle>
                {t('logOut')}
                <IconButton
                    onClick={() =>  handleCloseDialog()}
                    style={{position:"absolute",left:15,top:15}}
                    size="small"
                >
                    <Close className="lucide-icon"/>
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <Typography>{t('doYouWanaExit')}</Typography>
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={() => handleLogout()}
                >
                    {t('logOut')}
                </Button>
            </DialogActions>
        </Dialog>
    );
}

const mstp = state => ({
    isAuth: state.isAuth,
    user: state.user,
    primary_color: state.primary_color
});

export default withStyles(Styles)(connect(mstp)(LogoutDialog));
